import React from "react";
import DOMPurify from "dompurify";

const DomPurifyContent = ({ className, content }) => {
    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(content),
            }}
        />
    );
};

export default DomPurifyContent;

